(function() {
    angular
        .module("customersModule")
        .controller("CustomerDetailsController", CustomerDetailsController)

    CustomerDetailsController.$inject = [
        "$state",
        "$rootScope",
        "$scope",
        "$stateParams",
        "$uibModal",
        "customersService",
        "userMessagingService"
    ]

    function CustomerDetailsController(
        $state,
        $rootScope,
        $scope,
        $stateParams,
        $uibModal,
        customersService,
        userMessagingService
    ){
        "use strict"

        if (!$rootScope.can('CustomerRead', $stateParams.customer_id)) {

            $state.go("devices")

        }

        const DEFAULT_LRPM = 1
        const DEFAULT_LOPM = 20
        const DEFAULT_RRPM = 1
        const DEFAULT_RDPM = 4

        $rootScope.title = "Customer Details | WANCO"

        $scope.customer          = {}
        $scope.formSuccess       = false
        $scope.formFailure       = false
        $scope.formData          = {}
        $scope.allowSubSection   = $rootScope.customers.length > 1
        $scope.isEditing         = false
        $scope.canEditSubSection = $rootScope.can('SystemCustomerManageDOT', $scope.customer.id)
        $scope.canAdvancedEdit   = false
        $scope.apiWasEnabled     = false
        $scope.wzdxWasEnabled    = false
        $scope.apiEnabled        = false
        $scope.wzdxEnabled       = false
        $scope.wasDOT            = false
        $scope.isDOT             = false

        $scope.showApiAccessWarning    = false
        $scope.formApiConfigNeedsSave  = false
        $scope.formWZdxConfigNeedsSave = false

        $scope.showDOTRegionWarning = true
        $scope.allowDOTRegionChange = true

        $scope.formApiAccess = {
            devices_arrow_boards_allow: false,
            devices_locations_allow:    false,
            devices_workzone_allow:     false,
            devices_shares_create_allow: false,
            devices_shares_delete_allow: false,
            wzdx_devices_allow:         false,
            // wzdx_workzones_allow:       false
        }

        $scope.formDOT = {
            geo_iso: ""
        }

        $scope.formApiConfig = {
            limit_lrpm: DEFAULT_LRPM,
            limit_lopm: DEFAULT_LOPM,
            limit_rrpm: DEFAULT_RRPM,
            limit_rdpm: DEFAULT_RDPM
        }

        $scope.formWZDxConfig = {
            update_frequency: "30"
        }

        const checkCanEditSubSection = () => {

            if ($rootScope.can('CustomerSubMove', $scope.customer.parent_id) || $scope.customer.id === $rootScope.user.customer_id) {
                return true
            }

            const customerAndChildren = $rootScope.getUserCustomerAndChildren()

            for (const customer of customerAndChildren) {
                if ($scope.customer.id === customer.id) {
                    return true
                }
            }

            return false

        }

        const displayCustomer = (data) => {
            console.log(data)
            $scope.customer = data

            $scope.formData = {
                name:      $scope.customer.name,
                parent_id: $scope.customer.parent_id || null,
                address:   $scope.customer.address   || "",
                city:      $scope.customer.city      || "",
                state:     $scope.customer.state     || "",
                zip:       $scope.customer.zip       || "",
                country:   $scope.customer.country   || "",
                contact:   $scope.customer.contact   || "",
                phone:     $scope.customer.phone     || "",
                email:     $scope.customer.email     || ""
            }

            $scope.canAdvancedEdit   = $scope.formData.parent_id === "" || $scope.formData.parent_id === undefined || $scope.formData.parent_id === null
            $scope.couldAdvancedEdit = $scope.canAdvancedEdit
            $scope.canEditSubSection = checkCanEditSubSection()

            $scope.formApiConfigNeedsSave  = false
            $scope.formWZDxConfigNeedsSave = false

            $scope.allowDOTRegionChange = true

            $scope.wasDOT = false
            $scope.isDOT  = false

            if ($scope.customer.dot && $scope.customer.dot.geo_iso) {

                $scope.wasDOT = true
                $scope.isDOT  = true

                $scope.allowDOTRegionChange = false

                $scope.formDOT = {
                    geo_iso: $scope.customer.dot.geo_iso
                }

                $scope.wzdxWasEnabled = false
                $scope.wzdxEnabled    = false

                if ($scope.customer.wzdx.enabled) {

                    $scope.wzdxWasEnabled = true
                    $scope.wzdxEnabled    = true

                    $scope.customer.wzdx.config.update_frequency = String($scope.customer.wzdx.config.update_frequency)

                    if ($scope.customer.wzdx.hasOwnProperty("config")) {

                        $scope.formWZDxConfig = {
                            update_frequency: $scope.customer.wzdx.config.update_frequency
                        }
                    }
                }
            }

            $scope.apiWasEnabled = false
            $scope.apiEnabled    = false

            if ($scope.customer.api.enabled) {

                $scope.apiWasEnabled = true
                $scope.apiEnabled    = true

                if ($scope.customer.api.hasOwnProperty("config")) {

                    if ($scope.customer.api.config.hasOwnProperty("limits")) {
                        $scope.formApiConfig = {
                            limit_lrpm: $scope.customer.api.config.limits.lrpm,
                            limit_lopm: $scope.customer.api.config.limits.lopm,
                            limit_rrpm: $scope.customer.api.config.limits.rrpm,
                            limit_rdpm: $scope.customer.api.config.limits.rdpm
                        }
                    }

                    if ($scope.customer.api.config.hasOwnProperty("access")) {
                        $scope.formApiAccess = {
                            devices_arrow_boards_allow: $scope.customer.api.config.access.devices_arrow_boards_allow === true,
                            devices_locations_allow:    $scope.customer.api.config.access.devices_locations_allow === true,
                            devices_workzone_allow:     $scope.customer.api.config.access.devices_workzone_allow === true,
                            devices_shares_create_allow: $scope.customer.api.config.access.devices_shares_create_allow === true,
                            devices_shares_delete_allow: $scope.customer.api.config.access.devices_shares_delete_allow === true,
                            wzdx_devices_allow:         $scope.customer.api.config.access.wzdx_devices_allow === true,
                            // wzdx_workzones_allow:       $scope.customer.api.config.access.wzdx_workzones_allow === true
                        }
                    }
                }
            }
        }

        customersService.getCustomer($stateParams.customer_id, function(data) {
            displayCustomer(data)
        })

        $scope.toggleAPI = () => {

            if ($rootScope.can('SystemApiConfigUpdate', $scope.customer.id)) {

                if ($scope.canAdvancedEdit) {

                    if ($scope.apiEnabled) {

                        if (!$scope.apiWasEnabled) {
                            $scope.apiEnabled = false
                            return
                        }

                        const configID = $scope.customer.api.config.id

                        const performAction = () => {

                            const success = function(data) {
                                console.log(data)
                                displayCustomer(data)
                                $scope.formApiConfig = undefined
                                $scope.apiEnabled = false
                            }

                            const failure = function(error) {
                                userMessagingService.error(error)
                            }

                            customersService.deleteApiConfig($scope.customer.id, configID, success, failure)

                        }

                        $uibModal.open({
                            templateUrl: "app/modals/generic-confirmation-modal.view.html",
                            controller: "GenericConfirmationModalController",
                            resolve: {
                                title: () => {
                                    return "Confirm Disable API"
                                },
                                question: () => {
                                    return "Are you sure you want to disable the API?"
                                },
                                warning: () => {
                                    return "Disabling the API will immediately and permanently disable any existing API Keys."
                                },
                                buttonLabel: () => {
                                    return "Disable"
                                },
                                performAction: () => {
                                    return performAction
                                }
                            }
                        }).result.catch(function(res) {
                            $scope.apiEnabled = false
                            setTimeout(() => {
                                $scope.apiEnabled = true
                            }, 1)
                            if (!(res === "cancel" || res === "escape key press")) {
                                throw res
                            }
                        })

                    } else {

                        $scope.formApiConfig = {
                            limit_lrpm: DEFAULT_LRPM,
                            limit_lopm: DEFAULT_LOPM,
                            limit_rrpm: DEFAULT_RRPM,
                            limit_rdpm: DEFAULT_RDPM
                        }

                        $scope.formApiAccess = {
                            devices_arrow_boards_allow: false,
                            devices_locations_allow:    false,
                            devices_workzone_allow:     false,
                            devices_shares_create_allow: false,
                            devices_shares_delete_allow: false,
                            wzdx_devices_allow:         false,
                            // wzdx_workzones_allow:       false
                        }

                        if ($scope.customer.api.enabled) {

                            if ($scope.customer.api.hasOwnProperty("config")) {

                                if ($scope.customer.api.config.hasOwnProperty("limits")) {
                                    $scope.formApiConfig = {
                                        limit_lrpm: $scope.customer.api.config.limits.lrpm,
                                        limit_lopm: $scope.customer.api.config.limits.lopm,
                                        limit_rrpm: $scope.customer.api.config.limits.rrpm,
                                        limit_rdpm: $scope.customer.api.config.limits.rdpm
                                    }
                                }

                                if ($scope.customer.api.config.hasOwnProperty("access")) {
                                    $scope.formApiAccess = {
                                        devices_arrow_boards_allow: $scope.customer.api.config.access.devices_arrow_boards_allow === true,
                                        devices_locations_allow:    $scope.customer.api.config.access.devices_locations_allow === true,
                                        devices_workzone_allow:     $scope.customer.api.config.access.devices_workzone_allow === true,
                                        devices_shares_create_allow: $scope.customer.api.config.access.devices_shares_create_allow === true,
                                        devices_shares_delete_allow: $scope.customer.api.config.access.devices_shares_delete_allow === true,
                                        wzdx_devices_allow:         $scope.customer.api.config.access.wzdx_devices_allow === true,
                                        // wzdx_workzones_allow:       $scope.customer.api.config.access.wzdx_workzones_allow === true
                                    }
                                }
                            }
                        }

                        $scope.apiEnabled = true

                        $scope.checkApiForm()

                    }
                }
            }
        }

        $scope.toggleDOT = () => {

            if ($rootScope.can('SystemCustomerManageDOT', $scope.customer.id)) {

                if (!$scope.isDOT) {

                    $scope.formDOT = {
                        geo_iso: ""
                    }

                    $scope.isDOT = true

                    $scope.checkDOTForm()
                    return

                }

                if (!$scope.wasDOT) {
                    $scope.isDOT = false
                    return
                }

                const performAction = () => {
                    $scope.deleteDOT()
                }

                if (!$scope.wzdxWasEnabled) {
                    performAction()
                    return
                }

                $uibModal.open({
                    templateUrl: "app/modals/generic-confirmation-modal.view.html",
                    controller: "GenericConfirmationModalController",
                    resolve: {
                        title: () => {
                            return "Confirm Disable DOT Account"
                        },
                        question: () => {
                            return "Are you sure you want to disable this customer's DOT Account?"
                        },
                        warning: () => {
                            return "Disabling DOT Account will immediately disable WZDx Flat File access and delete any associated Username / Password."
                        },
                        buttonLabel: () => {
                            return "Disable"
                        },
                        performAction: () => {
                            return performAction
                        }
                    }
                }).result.catch(function(res) {
                    $scope.isDOT = false
                    setTimeout(() => {
                        $scope.isDOT = true
                    }, 1)
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        }

        $scope.toggleAPIAccess = (category) => {

            if (category === "DevicesArrowBoards") {
                $scope.formApiAccess.devices_arrow_boards_allow = !$scope.formApiAccess.devices_arrow_boards_allow
                $scope.checkApiForm()
                return
            }

            if (category === "DevicesLocations") {
                $scope.formApiAccess.devices_locations_allow = !$scope.formApiAccess.devices_locations_allow
                $scope.checkApiForm()
                return
            }

            if (category === "DevicesWorkzone") {
                $scope.formApiAccess.devices_workzone_allow = !$scope.formApiAccess.devices_workzone_allow
                $scope.checkApiForm()
                return
            }

            if (category === "DevicesSharesCreate") {
                $scope.formApiAccess.devices_shares_create_allow = !$scope.formApiAccess.devices_shares_create_allow
                $scope.checkApiForm()
                return
            }

            if (category === "DevicesSharesDelete") {
                $scope.formApiAccess.devices_shares_delete_allow = !$scope.formApiAccess.devices_shares_delete_allow
                $scope.checkApiForm()
                return
            }

            if (category === "WZDxDevices") {
                $scope.formApiAccess.wzdx_devices_allow = !$scope.formApiAccess.wzdx_devices_allow
                $scope.checkApiForm()
                return
            }

            // if (category === "WZDxWorkzones") {
            //     $scope.formApiAccess.wzdx_workzones_allow = !$scope.formApiAccess.wzdx_workzones_allow
            //     $scope.checkApiForm()
            //     return
            // }
        }

        $scope.toggleWZDx = () => {

            if ($rootScope.can('SystemApiConfigUpdate', $scope.customer.id)) {

                if ($scope.canAdvancedEdit) {

                    if ($scope.wzdxEnabled) {

                        if (!$scope.wzdxWasEnabled) {
                            $scope.wzdxEnabled = false
                            return
                        }

                        const configID = $scope.customer.wzdx.config.id

                        const performAction = () => {

                            const success = function(data) {
                                displayCustomer(data)
                                $scope.formWZDxConfig = undefined
                                $scope.wzdxEnabled = false
                            }

                            const failure = function(error) {
                                userMessagingService.error(error)
                            }

                            customersService.deleteWZDxConfig($scope.customer.id, configID, success, failure)

                        }

                        $uibModal.open({
                            templateUrl: "app/modals/generic-confirmation-modal.view.html",
                            controller: "GenericConfirmationModalController",
                            resolve: {
                                title: () => {
                                    return "Confirm Disable WZDx Flat File"
                                },
                                question: () => {
                                    return "Are you sure you want to disable the WZDx Flat File?"
                                },
                                warning: () => {
                                    return "Disabling the WZDx Flat File will immediately and permanently disable Username & Password."
                                },
                                buttonLabel: () => {
                                    return "Disable"
                                },
                                performAction: () => {
                                    return performAction
                                }
                            }
                        }).result.catch(function(res) {
                            $scope.wzdxEnabled = false
                            setTimeout(() => {
                                $scope.wzdxEnabled = true
                            }, 1)
                            if (!(res === "cancel" || res === "escape key press")) {
                                throw res
                            }
                        })

                    } else {

                        $scope.formWZDxConfig = {
                            update_frequency: "30"
                        }

                        if ($scope.customer.wzdx.enabled) {

                            if ($scope.customer.wzdx.hasOwnProperty("config")) {

                                $scope.formWZDxConfig = {
                                    update_frequency: $scope.customer.wzdx.config.update_frequency,
                                }
                            }
                        }

                        $scope.wzdxEnabled = true

                        $scope.checkWZDxForm()

                    }
                }
            }
        }

        $scope.editCustomer = (customerID) => {

            $scope.submitted = true

            if ($scope.editCustomerForm.$valid) {

                $scope.isEditing = true

                const success = (updatedCustomer) => {

                    $scope.isEditing = false

                    $rootScope.selectedCustomerID = $rootScope.user.customer_id

                    for (let i = 0; i < $rootScope.customers.length; i++) {
                        if ($rootScope.customers[i].id === $scope.customer.id) {
                            $rootScope.customers[i] = updatedCustomer
                            $rootScope.customers = [...$rootScope.customers] // Updates Header Customers
                            break
                        }
                    }

                    $state.go("customers", {}).then(() => {
                        userMessagingService.success("Customer Successfully Edited")
                    })
                }

                const failure = (error) => {
                    $scope.isEditing = false
                    userMessagingService.error(error)
                }

                customersService.editCustomer(customerID, angular.fromJson($scope.formData), success, failure)

            }
        }

        $scope.toggleDOTRegionRead = () => {

            if (!$scope.customer.is_dot || $scope.customer.dot.region_write) { return }

            $scope.customer.dot.region_read = !$scope.customer.dot.region_read

            const failure = () => {

                $scope.customer.dot.region_read = !$scope.customer.dot.region_read

                let message = "Enable"

                if ($scope.customer.dot.region_read) {
                    message = "Disable"
                }

                userMessagingService.error("Failed to " + message + " Regional Devices Read Access.")

            }

            customersService.updateDOTRegionAccess($scope.customer.id, $scope.customer.dot.region_read, $scope.customer.dot.region_write, undefined, failure)

        }

        $scope.toggleDOTRegionWrite = () => {

            if (!$scope.customer.is_dot) { return }

            $scope.customer.dot.region_write = !$scope.customer.dot.region_write
            $scope.customer.dot.region_read  = $scope.customer.dot.region_write

            const failure = () => {

                $scope.customer.dot.region_write = !$scope.customer.dot.region_write
                $scope.customer.dot.region_read  = $scope.customer.dot.region_write

                let message = "Enable"

                if ($scope.customer.dot.region_write) {
                    message = "Disable"
                }

                userMessagingService.error("Failed to " + message + " Regional Devices Read/Write Access.")

            }

            customersService.updateDOTRegionAccess($scope.customer.id, $scope.customer.dot.region_read, $scope.customer.dot.region_write, undefined, failure)

        }

        $scope.openCustomerDeleteModal = function(customer) {
            $scope.isEditing = true
            $uibModal.open({
                templateUrl: "app/modals/delete-customer-modal.view.html",
                controller:  "DeleteCustomerModalController",
                resolve: {
                    customer: function() {
                        return customer
                    }
                }
            }).result.catch(function(res) {
                $scope.isEditing = false
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.changeParent = () => {

            $scope.apiEnabled  = $scope.apiWasEnabled
            $scope.wzdxEnabled = $scope.wzdxWasEnabled
            $scope.isDOT       = $scope.wasDOT

            $scope.canAdvancedEdit = $scope.formData.parent_id === "" || $scope.formData.parent_id === undefined || $scope.formData.parent_id === null

            if (!$scope.canAdvancedEdit) {

                const performAction = () => {
                    $scope.apiEnabled  = false
                    $scope.wzdxEnabled = false
                    $scope.isDOT       = false
                }

                $uibModal.open({
                    templateUrl: "app/modals/generic-confirmation-modal.view.html",
                    controller: "GenericConfirmationModalController",
                    resolve: {
                        title: () => {
                            return "Confirm Change to Sub-Customer"
                        },
                        question: () => {
                            return "Are you sure you want to change this account to become a sub-customer?"
                        },
                        warning: () => {
                            return "Changing this account to become a sub-customer will immediately and permanently delete any DOT Account settings, API Access, and/or WZDx Flat File Access."
                        },
                        buttonLabel: () => {
                            return "Change"
                        },
                        performAction: () => {
                            return performAction
                        }
                    }
                }).result.catch(function(res) {

                    $scope.formData.parent_id = undefined

                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        }

        $scope.checkApiForm = () => {

            const check = () => {

                if (!$scope.formApiAccess.devices_arrow_boards_allow && !$scope.formApiAccess.devices_locations_allow && !$scope.formApiAccess.devices_workzone_allow && !$scope.formApiAccess.devices_shares_create_allow && !$scope.formApiAccess.devices_shares_delete_allow && !$scope.formApiAccess.wzdx_devices_allow) {
                // if (!$scope.formApiAccess.devices_arrow_boards_allow && !$scope.formApiAccess.devices_locations_allow && !$scope.formApiAccess.devices_workzone_allow && !$scope.formApiAccess.wzdx_devices_allow && !$scope.formApiAccess.wzdx_workzones_allow) {
                    $scope.showApiAccessWarning = true
                } else {
                    $scope.showApiAccessWarning = false
                }

                const lrpm = Math.max(1, Number($scope.formApiConfig.limit_lrpm) || 0)
                const lopm = Math.max(1, Number($scope.formApiConfig.limit_lopm) || 0)
                const rrpm = Math.max(1, Number($scope.formApiConfig.limit_rrpm) || 0)
                const rdpm = Math.max(1, Number($scope.formApiConfig.limit_rdpm) || 0)

                $scope.formApiConfig.limit_lrpm = String(lrpm)
                $scope.formApiConfig.limit_lopm = String(lopm)
                $scope.formApiConfig.limit_rrpm = String(rrpm)
                $scope.formApiConfig.limit_rdpm = String(rdpm)

                if (!$scope.customer.api.enabled) {
                    $scope.formApiConfigNeedsSave = true
                    return
                }

                if (lrpm !== $scope.customer.api.config.limits.lrpm) {
                    $scope.formApiConfigNeedsSave = true
                    return
                }

                if (lopm !== $scope.customer.api.config.limits.lopm) {
                    $scope.formApiConfigNeedsSave = true
                    return
                }

                if (rrpm !== $scope.customer.api.config.limits.rrpm) {
                    $scope.formApiConfigNeedsSave = true
                    return
                }

                if (rdpm !== $scope.customer.api.config.limits.rdpm) {
                    $scope.formApiConfigNeedsSave = true
                    return
                }

                if ($scope.formApiAccess.devices_arrow_boards_allow !== $scope.customer.api.config.access.devices_arrow_boards_allow) {
                    $scope.formApiConfigNeedsSave = true
                    return
                }

                if ($scope.formApiAccess.devices_locations_allow !== $scope.customer.api.config.access.devices_locations_allow) {
                    $scope.formApiConfigNeedsSave = true
                    return
                }

                if ($scope.formApiAccess.devices_workzone_allow !== $scope.customer.api.config.access.devices_workzone_allow) {
                    $scope.formApiConfigNeedsSave = true
                    return
                }

                if ($scope.formApiAccess.devices_shares_create_allow !== $scope.customer.api.config.access.devices_shares_create_allow) {
                    $scope.formApiConfigNeedsSave = true
                    return
                }

                if ($scope.formApiAccess.devices_shares_delete_allow !== $scope.customer.api.config.access.devices_shares_delete_allow) {
                    $scope.formApiConfigNeedsSave = true
                    return
                }

                if ($scope.formApiAccess.wzdx_devices_allow !== $scope.customer.api.config.access.wzdx_devices_allow) {
                    $scope.formApiConfigNeedsSave = true
                    return
                }

                // if ($scope.formApiAccess.wzdx_workzones_allow !== $scope.customer.api.config.access.wzdx_workzones_allow) {
                //     $scope.formApiConfigNeedsSave = true
                //     return
                // }

                $scope.formApiConfigNeedsSave = false

            }

            setTimeout(() => {
                $scope.$apply(check)
            }, 100)

        }

        $scope.checkDOTForm = () => {

            const check = () => {

                if ($scope.formDOT.geo_iso.length !== 5) {
                    $scope.showDOTRegionWarning = true
                } else {
                    $scope.showDOTRegionWarning = false
                }

                if (!$scope.customer.dot || !$scope.customer.dot.geo_iso || $scope.formDOT.geo_iso !== $scope.customer.dot.geo_iso) {
                    $scope.formDOTNeedsSave = true
                    return
                }

                $scope.formDOTNeedsSave = false

            }

            setTimeout(() => {
                $scope.$apply(check)
            }, 100)

        }

        $scope.checkWZDxForm = () => {

            const check = () => {

                if (!$scope.customer.wzdx.enabled) {
                    $scope.formWZDxConfigNeedsSave = true
                    return
                }

                if ($scope.formWZDxConfig.update_frequency !== $scope.customer.wzdx.config.update_frequency) {
                    $scope.formWZDxConfigNeedsSave = true
                    return
                }

                $scope.formWZDxConfigNeedsSave = false

            }

            setTimeout(() => {
                $scope.$apply(check)
            }, 100)

        }

        $scope.skipNonDigits = (event) => {
            if (!event.metaKey && !event.altKey && !event.ctrlKey && isNaN(event.key)) {
                event.preventDefault()
            }
        }

        $scope.saveDOT = () => {

            if ($rootScope.can('SystemCustomerManageDOT', $scope.customer.id)) {

                const success = function(data) {
                    displayCustomer(data)
                    userMessagingService.success("DOT Account Saved")
                }

                const failure = function(error) {
                    userMessagingService.error(error)
                }

                customersService.createDOT($scope.customer.id, $scope.formDOT, success, failure)

            }
        }

        $scope.deleteDOT = () => {

            if ($rootScope.can('SystemCustomerManageDOT', $scope.customer.id)) {

                const success = function(data) {
                    displayCustomer(data)
                    userMessagingService.success("DOT Account Removed")
                }

                const failure = function(error) {
                    userMessagingService.error(error)
                }

                customersService.deleteDOT($scope.customer.id, success, failure)

            }
        }

        $scope.saveApiConfig = () => {

            if ($rootScope.can('SystemApiConfigUpdate', $scope.customer.id)) {

                $scope.formApiConfig.limit_lrpm = Math.max(1, Number($scope.formApiConfig.limit_lrpm) || 0)
                $scope.formApiConfig.limit_lopm = Math.max(1, Number($scope.formApiConfig.limit_lopm) || 0)
                $scope.formApiConfig.limit_rrpm = Math.max(1, Number($scope.formApiConfig.limit_rrpm) || 0)
                $scope.formApiConfig.limit_rdpm = Math.max(1, Number($scope.formApiConfig.limit_rdpm) || 0)

                const formApi = {
                    ...$scope.formApiConfig,
                    ...$scope.formApiAccess
                }

                const success = function(data) {
                    displayCustomer(data)
                    userMessagingService.success("API Updated")
                }

                const failure = function(error) {
                    userMessagingService.error(error)
                }

                customersService.createApiConfig($scope.customer.id, formApi, success, failure)

                // if ($scope.customer.api.hasOwnProperty("config") && $scope.customer.api.config.id > 0) {

                //     customersService.updateApiConfig($scope.customer.id, $scope.customer.api.config.id, formApi, success, failure)

                // } else {

                //     customersService.createApiConfig($scope.customer.id, formApi, success, failure)

                // }
            }
        }

        $scope.saveWZDxConfig = () => {

            if ($rootScope.can('SystemApiConfigUpdate', $scope.customer.id)) {

                const success = function(data) {
                    displayCustomer(data)
                    userMessagingService.success("WZDx Flat File Updated")
                }

                const failure = function(error) {
                    userMessagingService.error(error)
                }

                customersService.createWZDxConfig($scope.customer.id, $scope.formWZDxConfig, success, failure)

            }
        }
    }
})()
